import * as React from 'react';
import { SVGProps } from 'react';

const IconNodeEndSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 3a1 1 0 0 0-1-1H2.5a1 1 0 0 0-1 1v.5a2.5 2.5 0 0 1 0 5V9a1 1 0 0 0 1 1H10a1 1 0 0 0 1-1V3z" />
    <path d="M1.5 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
  </svg>
);
export default IconNodeEndSizeXs;
